import { lazy } from 'react';

const SendProducerTransformerTransferConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/producer/consult/send-transfer-info',
			component: lazy(() => import('./SendTransferContainer'))
		}
	]
};

export default SendProducerTransformerTransferConfig;


